import type { ReactNode } from 'react';

/**
 * The line a list or panel shows in place of its rows: nothing yet, still
 * loading, or the read failed. Styled by `.empty-line` (styles/text.css).
 */
export function EmptyLine({ children }: { children: ReactNode }) {
  return <div className="empty-line">{children}</div>;
}
